import {
  createInitialIpawsAlertDraft,
  formatIpawsDateTimeWithOffset,
} from 'features/Weather/features/WeatherAlerts/features/AlertCreator/utils/alertCreator.utils';

const weaParametersFromLegacy = (data) => [
  ...(data.weaShortText ? [{ valueName: 'CMAMtext', value: data.weaShortText }] : []),
  ...(data.weaLongText ? [{ valueName: 'CMAMlongtext', value: data.weaLongText }] : []),
  ...(data.deliveryChannels?.includes('CMAS')
    ? [{ valueName: 'WEAHandling', value: 'WEA Test' }]
    : []),
];

const legacyDateTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? formatIpawsDateTimeWithOffset(date) : value;
};

/**
 * Read older Global Actions into the same draft model used by FEMA Alert Creator.
 * @param {import('./ipawsActionPayload.utils').IpawsActionFormData} [data] A saved or legacy action.
 * @returns {import('./ipawsActionPayload.utils').IpawsActionDraft} The draft with the nine keys set.
 */
export const normalizeIpawsActionDraft = (data = {}) => {
  const defaults = createInitialIpawsAlertDraft();
  return {
    ...defaults,
    ...data,
    intervalDuration: Number.isFinite(Number(data.intervalDuration))
      ? Math.max(0, Number(data.intervalDuration))
      : 0,
    category: Array.isArray(data.category)
      ? data.category
      : data.category
        ? [data.category]
        : defaults.category,
    responseType: Array.isArray(data.responseType)
      ? data.responseType
      : data.responseType
        ? [data.responseType]
        : defaults.responseType,
    effective:
      data.effective ??
      (data.startTime === undefined ? defaults.effective : legacyDateTime(data.startTime)),
    expires:
      data.expires ??
      (data.endTime === undefined ? defaults.expires : legacyDateTime(data.endTime)),
    hasConfirmedExpires: data.hasConfirmedExpires ?? Boolean(data.endTime),
    areaDesc: data.areaDesc ?? data.areaDescription ?? defaults.areaDesc,
    parameters: data.parameters ?? weaParametersFromLegacy(data),
    languages: data.languages ?? [],
  };
};
